import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '../context/ThemeContext';
import { ArrowLeftIcon, MailIcon } from '../components/Icons';
import './HelpSupport.css';

const HelpSupport = () => {
  const navigate = useNavigate();
  const { theme } = useTheme();
  const [expandedFaq, setExpandedFaq] = useState(null);

  const faqItems = [
    {
      question: 'How do I start a pickup?',
      answer: 'Navigate to your dashboard, select an assigned pickup, and tap "Start Pickup" to begin the collection process.'
    },
    {
      question: 'How do I update my profile?',
      answer: 'Go to Account Settings > Edit Profile to update your name, email, phone number, or profile picture.'
    },
    {
      question: 'What if I enter wrong weight information?',
      answer: 'You can edit the confirmed items before final submission. If already submitted, contact support for corrections.'
    },
    {
      question: 'How do I change my password?',
      answer: 'Go to Account Settings > Change Password to securely update your password.'
    },
    {
      question: 'How are payments processed?',
      answer: 'Payments are processed automatically based on completed pickups. Earnings are credited to your registered account.'
    },
    {
      question: 'What should I do if an order is cancelled?',
      answer: 'If a customer cancels, the order will be removed from your dashboard. No action is needed from your end.'
    }
  ];

  const toggleFaq = (index) => {
    setExpandedFaq(expandedFaq === index ? null : index);
  };

  return (
    <div className="help-screen">
      <div className="help-wrapper">
        {/* Header */}
        <header className="help-header">
          <button className="back-btn" onClick={() => navigate('/account')}>
            <ArrowLeftIcon size={20} color={theme === 'dark' ? '#ffffff' : '#0f172a'} />
          </button>
          <h1 className="help-title">Help & Support</h1>
          <div className="header-spacer"></div>
        </header>

        {/* Hero Section */}
        <div className="help-hero">
          <div className="hero-icon">
            <svg viewBox="0 0 24 24" fill="none">
              <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"/>
              <path d="M9.09 9a3 3 0 015.83 1c0 2-3 3-3 3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M12 17h.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            </svg>
          </div>
          <h2 className="hero-title">How can we help?</h2>
          <p className="hero-subtitle">Get in touch with our support team or find answers below</p>
        </div>

        {/* Contact Options */}
        <div className="contact-section">
          <h3 className="section-label">CONTACT US</h3>
          <div className="contact-cards">
            <a href="tel:+919910039125" className="contact-card">
              <div className="contact-icon phone">
                <svg viewBox="0 0 24 24" fill="none">
                  <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 16.92z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <div className="contact-info">
                <span className="contact-type">Call Us</span>
                <span className="contact-detail">+91 9910039125</span>
              </div>
              <svg viewBox="0 0 24 24" fill="none" className="contact-arrow">
                <path d="M9 18l6-6-6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </a>

            <a href="mailto:info@avrorecycling.com" className="contact-card">
              <div className="contact-icon email">
                <svg viewBox="0 0 24 24" fill="none">
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M22 6l-10 7L2 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <div className="contact-info">
                <span className="contact-type">Email Us</span>
                <span className="contact-detail">info@avrorecycling.com</span>
              </div>
              <svg viewBox="0 0 24 24" fill="none" className="contact-arrow">
                <path d="M9 18l6-6-6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </a>
          </div>
        </div>

        {/* FAQ Section */}
        <div className="faq-section">
          <h3 className="section-label">FREQUENTLY ASKED QUESTIONS</h3>
          <div className="faq-list">
            {faqItems.map((item, index) => (
              <div 
                key={index} 
                className={`faq-item ${expandedFaq === index ? 'expanded' : ''}`}
                onClick={() => toggleFaq(index)}
              >
                <div className="faq-header">
                  <span className="faq-question">{item.question}</span>
                  <svg viewBox="0 0 24 24" fill="none" className="faq-chevron">
                    <path d="M6 9l6 6 6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
                <div className="faq-answer">
                  <p>{item.answer}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Footer */}
        <div className="help-footer">
          <p>Support available Mon-Sat, 9 AM - 6 PM</p>
        </div>
      </div>
    </div>
  );
};

export default HelpSupport;
